import { useSettingsStore } from "@/data/settingsStore";

export interface PostersConfig {
  disableAll: boolean;
  showSeats: boolean;
  showPartyLink: boolean;
  showProgramLink: boolean;
  showWebsiteLink: boolean;
  autoSilenceElectoral: boolean;
  forceSilenceElectoral?: boolean;
  autoReorderByResults: boolean;
  lockPosters?: boolean;
}

const STORE_KEY = "kaynin_posters_config";

const defaultConfig: PostersConfig = {
  disableAll: false,
  showSeats: true,
  showPartyLink: true,
  showProgramLink: true,
  showWebsiteLink: true,
  autoSilenceElectoral: true,
  forceSilenceElectoral: false,
  autoReorderByResults: true,
  lockPosters: false
};

export function getPostersConfig(): PostersConfig {
  try {
    const raw = useSettingsStore.getState().getSetting(STORE_KEY, "");
    if (raw && typeof raw === "string") {
      return { ...defaultConfig, ...JSON.parse(raw) };
    }
  } catch (e) {
    console.error("Failed to parse posters config", e);
  }
  return defaultConfig;
}

export function savePostersConfig(config: PostersConfig) {
  useSettingsStore.getState().updateSetting(STORE_KEY, JSON.stringify(config));
}
